/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de idsState
 * @author Bene Lemuel Dantas Gondim
 * @file idsStateReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import * as actionTypes from 'actions'

const CryptoJS = require('crypto-js')

const secretKey = '^~{9P8lnIg@V`f+Y0~TTTDRdg#;bvq'

// Estado inicial da sessão no redux
let initialState
if (localStorage.getItem('@sigep/state')) {
  const bytes = CryptoJS.AES.decrypt(localStorage.getItem('@sigep/state'), secretKey)
  initialState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
} else {
  initialState = {}
}

const idsStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ID_ORGAO: {
      const newState = {
        ...state,
        idOrgao: action.idOrgao,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idOrgao: action.idOrgao,
      }
    }

    case actionTypes.ID_REGIONAL: {
      const newState = {
        ...state,
        idRegional: action.idRegional,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idRegional: action.idRegional,
      }
    }

    case actionTypes.ID_DIVISAO: {
      const newState = {
        ...state,
        idDivisao: action.idDivisao,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idDivisao: action.idDivisao,
      }
    }

    case actionTypes.ID_SETOR: {
      const newState = {
        ...state,
        idSetor: action.idSetor,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idSetor: action.idSetor,
      }
    }

    case actionTypes.ID_CARGO: {
      const newState = {
        ...state,
        idCargo: action.idCargo,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idCargo: action.idCargo,
      }
    }

    case actionTypes.ID_USUARIO: {
      const newState = {
        ...state,
        idUsuario: action.idUsuario,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idUsuario: action.idUsuario,
      }
    }

    case actionTypes.ID_EXAME: {
      const newState = {
        ...state,
        idExame: action.idExame,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idExame: action.idExame,
      }
    }

    case actionTypes.ID_CASO: {
      const newState = {
        ...state,
        idCaso: action.idCaso,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idCaso: action.idCaso,
      }
    }

    case actionTypes.ID_VESTIGIO: {
      const newState = {
        ...state,
        idVestigio: action.idVestigio,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idVestigio: action.idVestigio,
      }
    }

    case actionTypes.ID_SOLICITACAO_EXAME: {
      const newState = {
        ...state,
        idSolicitacaoExame: action.idSolicitacaoExame,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idSolicitacaoExame: action.idSolicitacaoExame,
      }
    }

    case actionTypes.ID_EXAME_SOLICITADO: {
      const newState = {
        ...state,
        idExameSolicitado: action.idExameSolicitado,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idExameSolicitado: action.idExameSolicitado,
      }
    }

    case actionTypes.ID_EXAME_REALIZADO: {
      const newState = {
        ...state,
        idExameRealizado: action.idExameRealizado,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idExameRealizado: action.idExameRealizado,
      }
    }

    case actionTypes.ID_CENTRAL_CUSTODIA: {
      const newState = {
        ...state,
        idCentralCustodia: action.idCentralCustodia,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idCentralCustodia: action.idCentralCustodia,
      }
    }

    case actionTypes.ID_PERICIANDO: {
      const newState = {
        ...state,
        idPericiando: action.idPericiando,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idPericiando: action.idPericiando,
      }
    }

    case actionTypes.ID_CADAVER: {
      const newState = {
        ...state,
        idCadaver: action.idCadaver,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idCadaver: action.idCadaver,
      }
    }
    case actionTypes.ID_LOCAL: {
      const newState = {
        ...state,
        idLocal: action.idLocal,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idLocal: action.idLocal,
      }
    }

    case actionTypes.ID_VEICULO: {
      const newState = {
        ...state,
        idVeiculo: action.idVeiculo,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())
      return {
        ...newState,
        idVeiculo: action.idVeiculo,
      }
    }

    case actionTypes.ID_SECAO_EXAME: {
      const newState = {
        ...state,
        idSecaoExame: action.idSecaoExame,
      }
      localStorage.setItem('@sigep/state', CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString())

      return {
        ...newState,
        idSecaoExame: action.idSecaoExame,
      }
    }

    default: {
      return state
    }
  }
}

export default idsStateReducer
